// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__iWFll","rotateHandler":"styles_rotateHandler__KciPN"};
module.exports.__checksum = "fe7cc00887f0"